import { gql } from 'apollo-boost';

const getOrgMembership = gql`
  query GetOrgMembership($organisationId: String!, $email: String!) {
    getOrgMembership(organisationId: $organisationId, email: $email)
      {
        userEmail
        status
        updatedAt
        role {
          roleId
          name
        }
      }
    }
`;

export default (() => ({
  query: getOrgMembership,
  module: 'organisations',
  ignoreCache: true,
  buildVariables: ({
    organisationId,
    email



  }) => ({
    organisationId, email
  })
}));